import api from "./api";

export const getHubPartners = async (hubId) => {
  const res = await api.get(`/hubpartner/${hubId}`);
  const data = res.data?.data;
  return data?.$values ?? data ?? [];
};

export const getHubRoles = async () => {
  const res = await api.get("/hubpartner/roles");
  const data = res.data?.data;
  return data?.$values ?? data ?? [];
};

export const inviteHubPartner = async (hubId, email, role) => {
  const res = await api.post("/hubpartner", { hubId, email, role });
  return res.data;
};

export const removeHubPartner = async (partnerId) => {
  const res = await api.delete(`/hubpartner/${partnerId}`);
  return res.data;
};